import { useEffect } from 'react';
import { useLocation } from 'react-router'

function PageTitles(props) {
    const history = useLocation();
    useEffect(() => {
        let searchValue = history.pathname.replace("/en/", "/");
        searchValue = searchValue.replace("/fa/", "/");
        
        let data = props.pages.filter((val) => val.route === history.pathname);
        if(!data.length) {
            data = null
        } else {
            data = data[0]
        }
        if(props.PageIndex){
            if(props.PageIndex[searchValue]){
                data = props.PageIndex[searchValue];
            }
        }
        if(data) {
            document.title = data.title + ' | ' + props.base;
            let meta = document.querySelector('meta[name=description]');
            if(meta){
                meta.remove();
            }
            let desc = document.createElement("meta");
            desc.name = 'description';
            desc.content = data.desc;
            document.getElementsByTagName('head')[0].appendChild(desc);
        } else {
            document.title = props.base;
        }
        return () => {
        }
    }, [history, props.base, props.pages, props.PageIndex]);

    return (null);
}

export default PageTitles;